export default __webpack_public_path__ + "static/media/banner_image.644b79b4.svg";